import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { switchMap } from "rxjs";

import { Action } from "@app/models";
import { Observable } from "rxjs";

import { ActionListItemService } from "../../services/action-list-item.service";

@Component({
  selector: "action-one2one-sms",
  template: `
    <div [innerHTML]="text | async" class=""></div>
    <div>
      <small *ngIf="item.param3?.length > 0" class="text-muted">
        <strong>{{ "message" | translate }}: </strong>{{ item.param3 }}
      </small>
    </div>
  `,
  styleUrls: ["./common.scss"],
})
export class ActionOne2OneSmsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() item: Action;

  text: Observable<string>;
  listenerName: Function;

  className = "action-one2one-sms-name";

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService,
    public itemService: ActionListItemService
  ) {}

  ngOnInit() {
    this.text = this.itemService.getYouTranslation(this.item).pipe(
      switchMap((youString: string) =>
        this.translateService.get("action_one2one_sms_text", {
          you: youString,
          name: `<span class="${this.className} text-link">${this.item.firstName} ${this.item.familyName}</span>`,
        })
      )
    );
  }

  ngAfterViewInit() {
    this.listenerName = this.itemService.createContactLinkListener(
      this.elementRef,
      this.renderer,
      this.className,
      this.item.contactId
    );
  }

  ngOnDestroy() {
    const listeners = [this.listenerName];
    listeners.forEach((listener: Function) => {
      if (listener) {
        listener();
      }
    });
  }
}
